import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import {
  AuthenticatedLoginResponse,
  LoginBaseRequest,
  LoginRequest,
  LoginResponse,
  VerifyTotpCodeRequest,
} from "./types";

const LOGIN = ApiRequestAdapter.create("/auth", HttpMethod.POST);
const SEND_TOTP_CODE_VIA_SMS = ApiRequestAdapter.create("/auth/send-totp-code-via-sms", HttpMethod.POST);
const VERIFY_TOTP_CODE = ApiRequestAdapter.create("/auth/verify-totp-code", HttpMethod.POST);
const REFRESH_TOKEN = ApiRequestAdapter.create("/auth/refresh-token", HttpMethod.POST);

export const authApi = {
  login: (request: LoginRequest): AxiosPromise<LoginResponse> => {
    return apiService.post(LOGIN.url, request);
  },
  sendTotpCodeViaSms: (request: LoginBaseRequest): AxiosPromise => {
    return apiService.post(SEND_TOTP_CODE_VIA_SMS.url, request);
  },
  // A verified code and a refresh always issue the token.
  verifyTotpCode: (request: VerifyTotpCodeRequest): AxiosPromise<AuthenticatedLoginResponse> => {
    return apiService.post(VERIFY_TOTP_CODE.url, request);
  },
  refreshToken: (): AxiosPromise<AuthenticatedLoginResponse> => {
    return apiService.post(REFRESH_TOKEN.url);
  },
};
